module.exports = __webpack_public_path__ + "static/media/app10.7f0e93e9.png";